import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import type { SxProps, Theme } from '@mui/material/styles';
import { ReactNode } from 'react';

import { mergeSx } from '@/utils/mergeSx';

import { mainContentStyles as sx } from './MainContent.styles';

type Props = {
	children: ReactNode;
	fullHeight?: boolean;
	customSx?: SxProps<Theme>;
};

export const MainContent = ({
	children,
	customSx,
	fullHeight = false
}: Props) => {
	return (
		<Stack
			direction='column'
			role='main'
			component='main'
			sx={sx.mainContentRoot}
		>
			<Container maxWidth='xl' disableGutters sx={sx.mainContentContainer}>
				{fullHeight ? (
					<Box sx={mergeSx(sx.mainContentFullHeightBox, customSx)}>
						{children}
					</Box>
				) : (
					<Box sx={customSx}>{children}</Box>
				)}
			</Container>
		</Stack>
	);
};
